__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "crunchorder-productinfo";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@crunchit/component-library", "1.2.5", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(616), __webpack_require__.e(98)]).then(() => (() => (__webpack_require__(9098))))));
			register("@crunchit/http-client", "1.3.3", () => (__webpack_require__.e(496).then(() => (() => (__webpack_require__(2496))))));
			register("@emotion/react", "11.13.3", () => (Promise.all([__webpack_require__.e(803), __webpack_require__.e(914), __webpack_require__.e(635)]).then(() => (() => (__webpack_require__(6635))))));
			register("@emotion/styled", "11.13.0", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(683), __webpack_require__.e(903)]).then(() => (() => (__webpack_require__(5903))))));
			register("@mui/material", "5.16.7", () => (Promise.all([__webpack_require__.e(803), __webpack_require__.e(233), __webpack_require__.e(251), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(683), __webpack_require__.e(315)]).then(() => (() => (__webpack_require__(1233))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-i18next", "14.1.3", () => (Promise.all([__webpack_require__.e(117), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(4117))))));
			register("react-router-dom", "6.27.0", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(3245))))));
			register("react-sortablejs", "6.1.4", () => (Promise.all([__webpack_require__.e(786), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(5786))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};